import { createPushNotification } from "src/modules/push-notification-protobuf";
import { Activities } from "src/modules/activity-log/activity";

export function createAwakeNotification({
  monitoringId,
  avatarName,
  avatarSex,
  audioUrl,
  imageUrl
}) {
  return createPushNotification({
    iosPayload: {
      aps: {
        category: "awake",
        alert: Activities.AWAKE,
        sound: "default",
        "mutable-content": 1
      },
      avatarName,
      avatarSex,
      audioUrl,
      imageUrl,
      monitoringId
    },
    androidPayload: {
      monitoringId,
      avatarName,
      avatarSex,
      audioUrl,
      imageUrl,
      type: "awake"
    },
    channel: "awake"
  });
}

export function createSleepingNotification({
  monitoringId,
  avatarName,
  avatarSex
}) {
  return createPushNotification({
    iosPayload: {
      aps: {
        category: "sleeping",
        alert: Activities.SLEEPING,
        sound: "default",
        "mutable-content": 1
      },
      monitoringId,
      avatarName,
      avatarSex
    },
    androidPayload: {
      monitoringId,
      avatarName,
      avatarSex,
      type: "sleeping"
    },
    channel: "sleeping"
  });
}

export function createMotionNotification({
  monitoringId,
  avatarName,
  avatarSex,
  imageUrl
}) {
  return createPushNotification({
    iosPayload: {
      aps: {
        category: "motion",
        alert: Activities.MOTION,
        sound: "default",
        "mutable-content": 1
      },
      monitoringId,
      avatarName,
      avatarSex,
      imageUrl
    },
    androidPayload: {
      monitoringId,
      avatarName,
      avatarSex,
      imageUrl,
      type: "motion"
    },
    channel: "motion"
  });
}
